import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';

@Component({
  selector: 'app-wo-notes-tab',
  templateUrl: './wo-notes-tab.component.html',
  standalone: false,
})
export class WoNotesTabComponent implements OnInit, OnChanges {
  @Input() headerId: string | null = null;
  @Input() readonly = false;

  rows: any[] = [];
  isLoaded = false;

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerId'] && !changes['headerId'].firstChange) {
      this.load();
    }
  }

  load(): void {
    if (!this.headerId) {
      this.isLoaded = true;
      return;
    }
    this.woService.getWorkOrder(this.headerId).subscribe({
      next: (res: any) => {
        this.rows = (res?.wo_notes ?? []).map((r: any) => ({...r}));
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  addRow(): void {
    this.rows.push({
      id: null,
      header_id: this.headerId,
      note: '',
      sort_order: (this.rows.length + 1) * 10,
    });
  }

  removeRow(index: number): void {
    this.confirmDialog.confirmThis(
      ['Delete this note?'],
      () => {
        this.rows.splice(index, 1);
      },
      () => {
      }
    );
  }

  save(): void {
    if (!this.headerId) {
      return;
    }
    this.woService.updateWorkOrder(this.headerId, {wo_header: {}, wo_notes: this.rows}).subscribe({
      next: () => {
        this.notification.showSuccessToast('Notes saved.');
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving notes.');
      }
    });
  }
}
